import { render, staticRenderFns } from "./HistoryData.vue?vue&type=template&id=49132ac2&"
import script from "./HistoryData.vue?vue&type=script&lang=ts&"
export * from "./HistoryData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports